var map = {
	"./fakeData.js": 1236,
	"./fonts/Poppinsbold.woff": 36474,
	"./fonts/Poppinsbold.woff2": 73324,
	"./fonts/Poppinsmedium.woff": 1914,
	"./fonts/Poppinsmedium.woff2": 13260,
	"./fonts/Poppinsregular.woff": 2831,
	"./fonts/Poppinsregular.woff2": 60287,
	"./fonts/Poppinssemibold.woff": 4268,
	"./fonts/Poppinssemibold.woff2": 51014,
	"./fonts/poppins.woff": 91529,
	"./fonts/poppins.woff2": 25065,
	"./icons/10am.svg": 84086,
	"./icons/3pm.svg": 47143,
	"./icons/7pm.svg": 44923,
	"./icons/add.svg": 71480,
	"./icons/alert-outline.svg": 5786,
	"./icons/arrow-up-icon.svg": 39954,
	"./icons/avatar-default.svg": 94608,
	"./icons/basket-red.svg": 85095,
	"./icons/before-sleep.svg": 64104,
	"./icons/blood-draw-date.svg": 33077,
	"./icons/blood-out-of-range.svg": 70304,
	"./icons/blood-show-groups.svg": 67090,
	"./icons/blood-sort-by-name.svg": 64584,
	"./icons/blood_icon.svg": 40823,
	"./icons/bottle.svg": 86295,
	"./icons/breakfast.svg": 31038,
	"./icons/calc.svg": 83224,
	"./icons/calendar-icon.svg": 85357,
	"./icons/check-fill.svg": 82373,
	"./icons/chevron-down-grey.svg": 82531,
	"./icons/chevron-down.svg": 79573,
	"./icons/chevron-left-green.svg": 30820,
	"./icons/chevron-left.svg": 12526,
	"./icons/chevron-right-black.svg": 1803,
	"./icons/chevron-right.svg": 19501,
	"./icons/chevron-up-green.svg": 42440,
	"./icons/chevron-up-grey.svg": 8614,
	"./icons/chevron-up.svg": 15738,
	"./icons/clear.svg": 37938,
	"./icons/close.svg": 35837,
	"./icons/components/Logo_Co-op.svg": 13305,
	"./icons/components/Logo_Evexia.svg": 59965,
	"./icons/components/address-icon.svg": 62333,
	"./icons/components/arrow-green.svg": 4328,
	"./icons/components/arrow-left-white.svg": 59108,
	"./icons/components/arrow-right-green.svg": 99565,
	"./icons/components/blood-custom-filter-active.svg": 59637,
	"./icons/components/blood-custom-filter.svg": 40942,
	"./icons/components/blood-marker-grey.svg": 9532,
	"./icons/components/blood-marker.svg": 87260,
	"./icons/components/blood_icon.svg": 80251,
	"./icons/components/bottle.svg": 56699,
	"./icons/components/bottles.svg": 23538,
	"./icons/components/check-circle-green.svg": 15544,
	"./icons/components/chevron-black-2.svg": 79811,
	"./icons/components/chevron-black.svg": 4466,
	"./icons/components/chevron-green.svg": 64034,
	"./icons/components/chevron-grey.svg": 26536,
	"./icons/components/clear-icon.svg": 15808,
	"./icons/components/close.svg": 60745,
	"./icons/components/copy-icon.svg": 60510,
	"./icons/components/date-2.svg": 63182,
	"./icons/components/delete-icon.svg": 8168,
	"./icons/components/deselect-all-icon.svg": 28046,
	"./icons/components/doctor-icon.svg": 45488,
	"./icons/components/dots-vertical.svg": 63626,
	"./icons/components/download-black.svg": 4885,
	"./icons/components/download-green.svg": 61133,
	"./icons/components/drag-handle-icon.svg": 18718,
	"./icons/components/edit.svg": 6419,
	"./icons/components/email-black.svg": 65195,
	"./icons/components/email-green.svg": 32667,
	"./icons/components/email-icon.svg": 30145,
	"./icons/components/end-evaluation.svg": 28741,
	"./icons/components/error-icon-red.svg": 31317,
	"./icons/components/file.svg": 72601,
	"./icons/components/filter.svg": 38045,
	"./icons/components/gear-icon.svg": 80860,
	"./icons/components/gluten_icon.svg": 12240,
	"./icons/components/icon-minus.svg": 61727,
	"./icons/components/icon-plus.svg": 65841,
	"./icons/components/info-circle-grey.svg": 22836,
	"./icons/components/info-circle-red.svg": 2166,
	"./icons/components/info-icon.svg": 69979,
	"./icons/components/lab-above.svg": 8472,
	"./icons/components/lab-below.svg": 55016,
	"./icons/components/login-icon.svg": 96992,
	"./icons/components/logo_drawer.svg": 68146,
	"./icons/components/logo_drawer_complete.svg": 51960,
	"./icons/components/logo_drawer_reports-only.svg": 86381,
	"./icons/components/logo_drawer_short.svg": 57385,
	"./icons/components/logo_drawer_survey-only.svg": 94802,
	"./icons/components/optimal-above.svg": 96191,
	"./icons/components/optimal-below.svg": 72259,
	"./icons/components/phone-icon.svg": 73945,
	"./icons/components/plus-circle-grey.svg": 75876,
	"./icons/components/plus-sm-green.svg": 72094,
	"./icons/components/plus-sm.svg": 28796,
	"./icons/components/portal_regestreted_icon.svg": 46548,
	"./icons/components/print-black.svg": 35962,
	"./icons/components/print-green.svg": 25210,
	"./icons/components/protocol-green-icon.svg": 92197,
	"./icons/components/protocol-pink-icon.svg": 5326,
	"./icons/components/protocol_icon.svg": 95713,
	"./icons/components/refresh-icon.svg": 87969,
	"./icons/components/report-download-icon.svg": 39312,
	"./icons/components/report-print-icon.svg": 13227,
	"./icons/components/report-send-email-icon.svg": 21195,
	"./icons/components/result-group-blood.svg": 68085,
	"./icons/components/result-group-survey.svg": 42389,
	"./icons/components/right-arrow-green.svg": 71637,
	"./icons/components/right-arrow.svg": 4371,
	"./icons/components/schedule-icons/schedule-icon_1.svg": 14583,
	"./icons/components/schedule-icons/schedule-icon_2.svg": 71460,
	"./icons/components/schedule-icons/schedule-icon_3.svg": 22629,
	"./icons/components/schedule-icons/schedule-icon_4.svg": 61530,
	"./icons/components/schedule-icons/schedule-icon_5.svg": 76139,
	"./icons/components/schedule-icons/schedule-icon_6.svg": 25400,
	"./icons/components/schedule-icons/schedule-icon_7.svg": 29641,
	"./icons/components/schedule-icons/schedule-icon_8.svg": 99854,
	"./icons/components/search.svg": 8011,
	"./icons/components/select-all-icon.svg": 49805,
	"./icons/components/select-icon-clear.svg": 20491,
	"./icons/components/star.svg": 95235,
	"./icons/components/success-icon-green.svg": 86824,
	"./icons/components/track-protocol.svg": 84397,
	"./icons/components/upload-cloud.svg": 95520,
	"./icons/components/user-card.svg": 38733,
	"./icons/components/vegan_icon.svg": 74362,
	"./icons/components/warning-icon.svg": 91769,
	"./icons/confirm-logo-title.svg": 87986,
	"./icons/copy-icon.svg": 29098,
	"./icons/cross.svg": 9973,
	"./icons/dashboard-doctor.svg": 43307,
	"./icons/dashboard-open-chats.svg": 91756,
	"./icons/dashboard-open-surveys.svg": 37728,
	"./icons/dashboard-protocol-ending.svg": 72550,
	"./icons/date.svg": 33463,
	"./icons/delete-icon.svg": 2668,
	"./icons/dinner.svg": 24067,
	"./icons/dollar-icon.svg": 70749,
	"./icons/dots-vertical_old-color.svg": 90562,
	"./icons/download-icon.svg": 94971,
	"./icons/edit.svg": 975,
	"./icons/email-icon-2.svg": 72116,
	"./icons/evaluation-download.svg": 34982,
	"./icons/evaluation-email.svg": 48866,
	"./icons/evaluation-print.svg": 14039,
	"./icons/filter.svg": 87985,
	"./icons/functional.svg": 26720,
	"./icons/gluten_icon.svg": 28932,
	"./icons/icon-done.svg": 50093,
	"./icons/info-circle-grey.svg": 11011,
	"./icons/info-circle-red.svg": 49194,
	"./icons/lab-above.svg": 31932,
	"./icons/lab-below.svg": 96388,
	"./icons/list.svg": 60071,
	"./icons/lunch.svg": 66729,
	"./icons/manually_added_icon.svg": 18385,
	"./icons/medi_herb_icon.svg": 318,
	"./icons/menu-icons/guide-active-icon.svg": 5405,
	"./icons/menu-icons/guide-icon.svg": 91476,
	"./icons/menu-icons/home-active-icon.svg": 48932,
	"./icons/menu-icons/home-icon.svg": 62583,
	"./icons/menu-icons/patient-active-icon.svg": 17514,
	"./icons/menu-icons/patient-icon.svg": 2345,
	"./icons/menu-icons/settings-active-icon.svg": 72622,
	"./icons/menu-icons/settings-icon.svg": 42853,
	"./icons/money.svg": 45649,
	"./icons/money2.svg": 7409,
	"./icons/more-icon.svg": 4646,
	"./icons/optimal-above.svg": 59691,
	"./icons/optimal-below.svg": 12391,
	"./icons/phone-icon-2.svg": 77884,
	"./icons/portal_regestreted_icon.svg": 2040,
	"./icons/preview-icon.svg": 48605,
	"./icons/protocol-green-icon.svg": 58377,
	"./icons/protocol-pink-icon.svg": 37170,
	"./icons/protocol_icon.svg": 86589,
	"./icons/purse.svg": 20788,
	"./icons/read-icon.svg": 34719,
	"./icons/read.svg": 88443,
	"./icons/refresh.svg": 32304,
	"./icons/reset.svg": 67244,
	"./icons/result-group-blood.svg": 23249,
	"./icons/result-group-default.svg": 4838,
	"./icons/result-group-survey.svg": 46017,
	"./icons/results-tab/Info.svg": 5088,
	"./icons/results-tab/check-circle-green.svg": 20455,
	"./icons/results-tab/icon-plus-2.svg": 78509,
	"./icons/results-tab/icon-trash.svg": 69830,
	"./icons/results-tab/plus-circle-grey.svg": 68695,
	"./icons/right-arrow.svg": 14263,
	"./icons/search.svg": 64343,
	"./icons/select-arrow.svg": 73335,
	"./icons/select-avatar.svg": 62879,
	"./icons/supply-days.svg": 95878,
	"./icons/system-avatar.svg": 10522,
	"./icons/tablet-green.svg": 20897,
	"./icons/tablet.svg": 73495,
	"./icons/upload_avatar.svg": 27764,
	"./icons/upon-arising.svg": 31243,
	"./icons/vegan_icon.svg": 70454,
	"./icons/vitamins.png": 70408,
	"./icons/warning.svg": 42865,
	"./images/SurveyForm2PCEng.jpg": 61836,
	"./images/SurveyForm2PCSpn.jpg": 64213,
	"./images/SurveyForm3PCEng.jpg": 54391,
	"./images/back-dp.jpg": 12409,
	"./images/logo.svg": 3914,
	"./images/logo_drawer.svg": 9766,
	"./images/pending-icon.svg": 89746,
	"./images/slider/patient-portal-home.jpeg": 45572,
	"./images/slider/qr-slide.jpeg": 70473,
	"./images/slider/slide1.jpeg": 11686,
	"./images/slider/slide2.jpeg": 33171,
	"./images/slider/slide3.jpeg": 56492,
	"./images/success.svg": 92572,
	"./images/survey.svg": 83153,
	"./images/temp-icon.jpg": 58607,
	"./sounds/quick-entry/chpok.mp3": 33232,
	"./sounds/quick-entry/done.mp3": 82571,
	"./sounds/quick-entry/error.mp3": 44683,
	"./sounds/quick-entry/guu.mp3": 99304,
	"./sounds/quick-entry/qwa-qwa.mp3": 57642
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13820;